import {
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  SET_PROFILE_SETTINGS_LOADING,
  GET_PROFILE_SETTINGS,
  GET_PROFILE_SETTINGS_SUCCESS,
  CHANGE_PERMISSIONS,
  CHANGE_PERMISSIONS_SUCCESS,
  CLEAR_PROFILE_TEMP_DATA,
  GET_SCHOOL_BY_TENANT,
  GET_SCHOOL_BY_TENANT_SUCCESS,
  GET_SCHOOL_BY_TENANT_ERROR,
  GET_ROUTES_FOR_PROFILE,
  GET_ROUTES_FOR_PROFILE_SUCCESS,
} from '../constants/ActionTypes';

export const getCurrentUser = () => ({
  type: GET_CURRENT_USER,
});

export const getCurrentUserSuccess = user => ({
  type: GET_CURRENT_USER_SUCCESS,
  payload: { user },
});

export const setProfileSettingsLoading = isLoading => ({
  type: SET_PROFILE_SETTINGS_LOADING,
  payload: { isLoading },
});

export const getProfileSettings = userId => ({
  type: GET_PROFILE_SETTINGS,
  payload: { userId },
});

export const getProfileSettingsSuccess = settings => ({
  type: GET_PROFILE_SETTINGS_SUCCESS,
  payload: { settings },
});

export const getProfileRoutes = routeIds => ({
  type: GET_ROUTES_FOR_PROFILE,
  payload: { routeIds },
});

export const getProfileRoutesSuccess = routes => ({
  type: GET_ROUTES_FOR_PROFILE_SUCCESS,
  payload: { routes },
});

export const changeProfilePermissions = (userId, permissions) => ({
  type: CHANGE_PERMISSIONS,
  payload: { userId, permissions },
});

export const changeProfilePermissionsSuccess = permissions => ({
  type: CHANGE_PERMISSIONS_SUCCESS,
  payload: { permissions },
});

export const changePassword = ({ newPassword, currentPassword }) => ({
  type: CHANGE_PASSWORD,
  payload: { newPassword, currentPassword },
});

export const changePasswordSuccess = () => ({
  type: CHANGE_PASSWORD_SUCCESS,
});

export const changePasswordError = error => ({
  type: CHANGE_PASSWORD_ERROR,
  payload: error,
});

export const clearProfileTempData = () => ({
  type: CLEAR_PROFILE_TEMP_DATA,
});

export const getSchoolByTenant = () => ({
  type: GET_SCHOOL_BY_TENANT,
});

export const getSchoolByTenantSuccess = school => ({
  type: GET_SCHOOL_BY_TENANT_SUCCESS,
  payload: { school },
});

export const getSchoolByTenantError = error => ({
  type: GET_SCHOOL_BY_TENANT_ERROR,
  payload: { error },
});
